import axios from 'axios';
import { onscreenTestHeaders, baseURL, createHeaders } from './constants';

const hostname = window.location.hostname;

const stageHostnames = ["localhost", "finhub-stage.habilelabs.io"];
const apiMap = {
  "customer-test.finhub.habilelabs.io": "https://api-tejas-test.finhub.habilelabs.io",
  "customer.finhub.habilelabs.io": "https://api-tejas.finhub.habilelabs.io"
};

const onscreenApiUrl = stageHostnames.includes(hostname)
  ? "https://api-tejas-stage.finhub.habilelabs.io"
  : apiMap[hostname] || "https://api-gate.finhub.habilelabs.io";
  

const collectiveApiPostRequest = async (payload, apiUrl) => {
  return axios.post(`${onscreenApiUrl}${apiUrl}`, payload, {
    headers: onscreenTestHeaders(),
  });
};

const collectiveApiGetRequest = async (payload, apiUrl) => {
  const queryParams = new URLSearchParams(payload).toString();
  return axios.get(`${onscreenApiUrl}${apiUrl}?${queryParams}`, {
    headers: onscreenTestHeaders(),
  });
};

const collectiveApiRequest = async (payload, apiUrl) => {
  return collectiveApiPostRequest(payload, apiUrl);
};


const aadhaarMasking = async (payload) => {
  const { apiKey, apiSecret, uploadImage } = payload;
  const headers = {
    api_key: apiKey,
    api_secret: apiSecret,
    api_url: 'aadhaar-masking',
    maxBodyLength: Infinity,
  };
  return axios.post(`${onscreenApiUrl}/v1/aadhaar-masking`, uploadImage, {
    headers,
  });
};

const createDigiLockerUrl = async () => {
  return axios.post(`${onscreenApiUrl}/v1/digilocker-url`, {
    "signup": true,
  });
};

const panVerification = async (payload) => {
  const { apiKey, apiSecret, entity } = payload;
  const headers = {
    api_key: apiKey,
    api_secret: apiSecret,
  };

  return axios.post(
    `${onscreenApiUrl}/pan-verification`,
    { entity },
    { headers },
  );
};

const updatedCredits = async (id) => {
  return axios.get(`${baseURL}/companies/${id}`);
};


const postFile = async (payload) => {
  const { file, number } = payload;
  const formData = new FormData();

  formData.append('file', file);
  if (number){
    formData.append('number', number);
  }

  return axios.post(
    `https://api-gate.finhub.habilelabs.io/api/v1/vault`, 
    formData, 
    {
      headers: {
        ...onscreenTestHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    }
  )
};

const downloadToken = async (token) => {
  const url = `https://api-gate.finhub.habilelabs.io/api/v1/un-vault?token=${token}`;
  try {
    const response = await axios.get(url, { headers: onscreenTestHeaders(), responseType: 'blob' });
    return response;
  } catch (error) {
    console.error('Error downloading data:', error);
    throw error;
  }
};


const postFileToVaults = async (payload) => {
  const { token, documentName, documentType, response, apiName  } = payload;

  return axios.post(`${baseURL}/vaults`, {
    data: {
      token: token,
      documentName: documentName,
      documentType: documentType,
      response: response || '',
      apiName: apiName
    } 
  }, {headers: createHeaders()});
};

export {
  aadhaarMasking,
  updatedCredits,
  panVerification,
  collectiveApiRequest,
  collectiveApiPostRequest,
  collectiveApiGetRequest,
  postFile,
  postFileToVaults,
  downloadToken,
  createDigiLockerUrl
};
